import React, { useEffect, useRef } from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  InputAdornment,
  IconButton,
  SvgIcon,
  Typography,
  makeStyles,
  Collapse,
  Tooltip,
  Zoom,
  CircularProgress,
  useTheme,
  FormControlLabel,
  Switch,
  Checkbox,
  MenuItem
} from '@material-ui/core';
import Edit from '@material-ui/icons/Edit';
import { red } from '@material-ui/core/colors';
import SrchSubResults from './SrchSubResults';
import Alert from '@material-ui/lab/Alert';
import useSubSearch from './useSubSearch';
import clsx from 'clsx';
import { useRequest } from 'src/hooks';
import { setup } from 'src/lib/endpoints';

import {
  Close,
  Search,
  Cancel,
  Clear,
  InfoOutlined,
  Add,
  Save
} from '@material-ui/icons';
import AddAPhoto from '@material-ui/icons/AddAPhoto';
import ImageUploader from 'src/components/ImageUploader';
import { useSelector } from 'react-redux';
import SubAccForm, { useSubAccForm } from '../SubAccForm';
import { useToggle } from 'src/hooks';
// import DebounceTextField from '../DebounceTextField';
import { DebounceTextField2 as DebounceTextField } from '../DebounceTextField2';
// const DebounceTextField = DebounceTextField2;
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom ref={ref} {...props} />;
});

const useStyles = makeStyles(theme => ({
  root: {
    padding: 0,
    display: 'flex',
    alignItems: 'center'
  },
  input: {
    padding: '1px',
    paddingLeft: '-2px',
    flex: 1
  },
  iconButton: {
    padding: 10,
    margin: '1px'
  },
  adornStart: {
    paddingLeft: 1
  },
  adornEnd: {
    paddingRight: 4
  },
  divider: {
    height: 28,
    margin: 2,
    marginRight: 0
  },
  dialogContent: {
    height: 500,
    padding: 0
  },
  spaceBetween: {
    display: 'flex',
    justifyContent: 'space-between'
  }
}));

const SrchSub = ({
  className,
  ixSubType,
  sSubType = '',
  selectedSub,
  selectedSubId,
  handleSubSelectRoot,
  onClose,
  fld,
  error,
  errorMessage,
  handleCreateSubAccount,
  showAdd = true,
  showEdit = true,
  forceOpen = false,
  isEditable = true,
  required = false,
  disregardLimits = false,
  autoSelect = true,
  hideCaption = false,
  containerProps = {},
  autoOpen = false,
  showDeactivateToggle = false,
  showInactiveToggle = false,
  transDetails = {},
  setTransDetails = () => {},
  quick_edit = false,
  ...rest
}) => {
  const request = useRequest();
  const didMount = useRef(false);
  const prevSubType = useRef(false);
  const theme = useTheme();
  const classes = useStyles();
  const [isOpen, open, close] = useToggle(forceOpen || autoOpen || false);
  const [selectedSubItem, setSelectedSubItem] = React.useState(null);
  const [selectedSubItemDetails, setSelectedSubItemDetails] = React.useState(
    null
  );
  const [openUploader, setOpenUploader] = React.useState(false);
  const [uploadSubId, setUploadSubId] = React.useState(null);
  const [uploadedFile, setUploadedFile] = React.useState(null);
  const [pendingImage, setPendingImage] = React.useState(null); // { name, file }
  const [pendingPreviewUrl, setPendingPreviewUrl] = React.useState(null);
  const { ixImage, userToken } = useSelector(state => state.auth);

  React.useEffect(() => {
    if (autoOpen) open();
  }, [autoOpen]);

  // Build local preview URL for pending image and clean up
  useEffect(() => {
    if (pendingImage?.file) {
      const url = URL.createObjectURL(pendingImage.file);
      setPendingPreviewUrl(url);
      return () => URL.revokeObjectURL(url);
    } else {
      setPendingPreviewUrl(null);
    }
  }, [pendingImage]);

  // Reset previews when switching to a different record or when form is (re)opened
  useEffect(() => {
    // Set current context sub id for uploads; clear any previews from other records
    setUploadSubId(subAccDetails?.ixSub || null);
    setPendingImage(null);
    setPendingPreviewUrl(null);
    // Only keep uploaded preview if it belongs to this ixSub
    if (subAccDetails?.ixSub && uploadSubId !== subAccDetails.ixSub) {
      setUploadedFile(null);
    }
    setOpenUploader(false);
  }, [subAccDetails?.ixSub, isFormOpen]);

  const autoSelectIfEmpty =
    autoSelect && (selectedSub === '' || selectedSub === null);
  const additionalFlds = {
    fld,
    index: rest?.index,
    forceOpen
  };

  const { filterByParent, ixSubParent, sSubParent, ixSubParentSource } =
    rest || {};

  const {
    loading,
    loadingOff,
    loadingOn,
    subList,
    error: errorSrch,
    meta,
    closeForm,
    subAccDetails,
    query,
    setQuery,
    editSubAcc,
    isFormOpen,
    createSubAcc,
    showInactive,
    toggleInactive,
    parentSubList
  } = useSubSearch({
    ixSubType,
    sSubType,
    disregardLimits,
    autoSelect: autoSelectIfEmpty,
    selectSub: handleSubSelectRoot,
    isOpen,
    showEdit,
    showAdd,
    transDetails: transDetails,
    ...additionalFlds,
    ...rest
  });

  useEffect(() => {
    if (!subList) {
      return;
    }
    const matches = subList.filter(
      item =>
        (selectedSubId != null && item.ixSub === selectedSubId) ||
        (selectedSubId == null && item.sSub === selectedSub)
    );
    // modified matching, if more than 1 result found, don't return a value
    let foundItem = matches.length === 1 ? matches[0] : null;

    if (!foundItem && selectedSubId) {
      foundItem = { ixSub: selectedSubId, sSub: selectedSub || '' };
    }

    if (foundItem) {
      setSelectedSubItemDetails(foundItem);
      setSelectedSubItem(foundItem);
    } else {
      setSelectedSubItem(null);
      setSelectedSubItemDetails(null);
    }
  }, [subList, selectedSubId, selectedSub]);

  useEffect(() => {
    if (!selectedSub || typeof selectedSub !== 'string') {
      setQuery('');
    } else {
      if (!subList.length) {
        setQuery(selectedSub);
      }
    }
  }, [selectedSub, selectedSubId]);

  const {
    isLoading,
    updateField,
    updateKVSField,
    updateSubLink,
    updateSubParent,
    addAtc,
    removeAtc,
    save,
    errors,
    sub,
    hasChanges
  } = useSubAccForm({
    subType: { ixSubType, sSubType },
    subTypeMeta: meta,
    subAcc: subAccDetails
  });

  const handleChangeSubParent = e => {
    const { value } = e.target;

    const selectedItem = (parentSubList || []).find(
      item => item?.ixSub === value || item?.ixBrch === value
    );

    if (!selectedItem) {
      return;
    }

    setTransDetails(prev => ({
      ...prev,
      [ixSubParentSource]: {
        ...prev?.[ixSubParentSource],
        sub_title: selectedItem?.sSub || '',
        value
      }
    }));
  };

  const handleSrchSub = e => {
    const value = e.target.value;
    if (value !== '' || typeof value !== 'undefined' || value !== null) {
      const lastChar = value[value.length - 1];
      setQuery(lastChar);
    }

    open();
  };

  const handleSubSelect = async (item, event = null, type = null) => {
    setSelectedSubItem(item);
    setSelectedSubItemDetails(item);

    if (type === 'edit' && event) {
      event.stopPropagation();
      // Open dialog with selected sub-account
      editSubAcc(item.ixSub);
      open();
    } else {
      close();
      handleSubSelectRoot({
        ...item,
        ...additionalFlds
      });
    }
  };
  // moved down to access handleSubSelect
  async function handleSave() {
    const { success, data } = await save();

    if (success) {
      // If there is a pending image, upload it now after we have ixSub
      if (pendingImage && (data?.ixSub || subAccDetails?.ixSub)) {
        const subId = data?.ixSub || subAccDetails?.ixSub;
        try {
          const formData = new FormData();
          formData.append('file', pendingImage.file);
          await fetch(`/api/images/sub/${subId}`, {
            method: 'POST',
            headers: { 'x-access-tokens': userToken },
            body: formData
          });
          setUploadedFile(pendingImage.name);
          setUploadSubId(subId);
          // set primary avatar as before
          await setPrimaryFromUploaded(pendingImage.name, subId);
        } catch (e) {
          // ignore upload error to not block save
        } finally {
          setPendingImage(null);
        }
      }
      closeForm();
      close();
      loadingOn();
      const res = await request.post(setup.sub.list, {
        ixSubType,
        q: data.ixSub,
        showInactive
      });
      let newSubList = [];
      if (res.success) {
        newSubList = res.data?.sub_list || [];
        if (newSubList.length == 1) {
          handleSubSelect(newSubList[0]);
        }
      }
      loadingOff();
      // setQuery(String(data?.ixSub ?? data?.sSub ?? ''));
    }
  }

  async function handleAddPhoto() {
    // Do not auto-save the form. Just open uploader in defer mode
    const subId = subAccDetails?.ixSub || null;
    if (subId) setUploadSubId(subId);
    setOpenUploader(true);
  }

  async function setPrimaryFromUploaded(fileName, subIdParam) {
    try {
      const headers = new Headers();
      headers.append('pragma', 'no-cache');
      headers.append('cache-control', 'no-cache');
      const getRes = await fetch(
        `/api/images/${ixImage}/sub/${subIdParam ?? uploadSubId}/${fileName}`,
        { method: 'GET', headers }
      );
      const imageBlob = await getRes.blob();
      const formData = new FormData();
      const file = new File([imageBlob], 'active_prod_avatar.jpg');
      formData.append('file', file);
      await fetch(`/api/images/sub/${subIdParam ?? uploadSubId}`, {
        method: 'POST',
        headers: { 'x-access-tokens': userToken },
        body: formData
      });
    } catch (e) {
      // ignore
    }
  }

  useEffect(() => {
    if (didMount.current == false) {
      didMount.current = true;
      return;
    }
    if (prevSubType.current == ixSubType) {
      return;
    }
    if (!prevSubType.current) {
      prevSubType.current = ixSubType;
      return;
    }
    prevSubType.current = ixSubType;
    setSelectedSubItem(null);
    setSelectedSubItemDetails(null);
    handleSubSelect({
      ixSubAcc: '',
      sSubAcc: '',
      ixSub: '',
      sSub: '',
      sub_id: '',
      sub_title: ''
    });
    setQuery('');
  }, [ixSubType]);
  const cancelSubAccForm = () => {
    closeForm();
  };

  const disabled = () => {
    return ixSubType === 0 || !isEditable || loading;
  };

  return (
    <Box {...containerProps}>
      <Dialog
        onClose={close}
        fullWidth
        scroll="paper"
        TransitionComponent={Transition}
        open={isOpen}
      >
        <DialogTitle>
          {!isFormOpen ? (
            <>
              <DebounceTextField
                fullWidth
                delay={200}
                value={query}
                onChange={e => setQuery(e.target.value)}
                autoComplete="off"
                autoFocus
                // autoSelect
                InputProps={{
                  disableUnderline: true,
                  autoFocus: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SvgIcon color="action">
                        <Search />
                      </SvgIcon>
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <>
                      {Boolean(filterByParent) && Boolean(ixSubParent) && (
                        <InputAdornment position="end">
                          <TextField
                            value={transDetails?.[ixSubParentSource]?.value}
                            InputProps={{
                              disableUnderline: true
                            }}
                            style={{
                              flex: 1
                            }}
                            onChange={handleChangeSubParent}
                            select
                          >
                            <MenuItem key={0} value={0}>
                              Select {sSubParent ? sSubParent : ''}
                            </MenuItem>
                            {(parentSubList || []).map(
                              ({ sSub, ixSub, ixBrch }) => (
                                <MenuItem
                                  key={ixSub || ixBrch}
                                  value={ixSub || ixBrch}
                                >
                                  {sSub}
                                </MenuItem>
                              )
                            )}
                          </TextField>
                        </InputAdornment>
                      )}

                      {Boolean(showInactiveToggle) && (
                        <Tooltip title="Show inactive" arrow>
                          <Checkbox
                            checked={showInactive}
                            onChange={toggleInactive}
                            size="small"
                          />
                        </Tooltip>
                      )}
                      {showAdd && (
                        <InputAdornment position="end">
                          <Tooltip title={'Add ' + sSubType} arrow>
                            <span>
                              <IconButton
                                onClick={createSubAcc}
                                tabIndex={-1}
                                size="small"
                              >
                                <Add />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </InputAdornment>
                      )}
                      <InputAdornment position="end">
                        <Tooltip title="Close" arrow>
                          <span>
                            <IconButton
                              onClick={close}
                              tabIndex={-1}
                              size="small"
                            >
                              <Close />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </InputAdornment>
                    </>
                  )
                }}
                placeholder={sSubType || 'Search...'}
                variant="standard"
              />
              <Collapse in={forceOpen}>
                <Box mt={1}>
                  <Alert severity="info">Select {sSubType} First</Alert>
                </Box>
              </Collapse>
              <Collapse in={errorSrch}>
                <Box mt={1}>
                  <Alert severity="error">Something went wrong.</Alert>
                </Box>
              </Collapse>
            </>
          ) : (
            <>
              <Box display="flex" justifyContent="space-between">
                <Typography
                  variant="h4"
                  component="p"
                  color="textSecondary"
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <InfoOutlined style={{ marginRight: '.4em' }} />
                  {subAccDetails?.ixSub
                    ? `${sSubType} (Update)`
                    : `${sSubType} (Create)`}
                </Typography>
                <Box display="flex" gridColumnGap={theme.spacing(1)}>
                  <Tooltip title="Save" arrow>
                    <span>
                      <IconButton
                        size="small"
                        tabIndex={-1}
                        onClick={handleSave}
                      >
                        <Save />
                      </IconButton>
                    </span>
                  </Tooltip>
                  {(meta?.photos == 1 || meta?.settings?.photos == 1) && (
                    <Tooltip title="Add Photo" arrow>
                      <span>
                        <IconButton
                          size="small"
                          tabIndex={-1}
                          onClick={handleAddPhoto}
                        >
                          <AddAPhoto />
                        </IconButton>
                      </span>
                    </Tooltip>
                  )}
                  <Tooltip title="Cancel" arrow>
                    <span>
                      <IconButton
                        size="small"
                        tabIndex={-1}
                        onClick={cancelSubAccForm}
                      >
                        <Cancel />
                      </IconButton>
                    </span>
                  </Tooltip>
                </Box>
              </Box>
            </>
          )}
        </DialogTitle>
        <Divider />
        <DialogContent className={classes.dialogContent}>
          {loading && (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <CircularProgress size={40} />
            </Box>
          )}
          {!loading && !isFormOpen && subList.length === 0 && query === '' && (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <Box display="flex" justifyContent="center" alignItems="center">
                <Search color="primary" fontSize="large" />
                <Typography variant="h5" color="primary">
                  Search {sSubType}
                </Typography>
              </Box>
            </Box>
          )}
          {!loading &&
            !isFormOpen &&
            subList.length === 0 &&
            (query || '').trim() !== '' && (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <Box display="flex" justifyContent="center" alignItems="center">
                  <Search color="primary" fontSize="large" />
                  <Typography variant="h5" color="primary">
                    No Result Found
                  </Typography>
                </Box>
              </Box>
            )}
          {!loading && subList.length > 0 && !isFormOpen && (
            <SrchSubResults
              subList={subList}
              handleSubSelect={handleSubSelect}
              showEdit={showEdit}
              ixSubType={ixSubType}
              selectedSub={selectedSubItem}
            />
          )}
          {/* Create and Update */}
          {!loading && isFormOpen && (
            <Box p={2}>
              <SubAccForm
                subTypeMeta={meta}
                subAcc={sub}
                updateField={updateField}
                updateKVSField={updateKVSField}
                updateSubParent={updateSubParent}
                updateSubLink={updateSubLink}
                addAtc={addAtc}
                removeAtc={removeAtc}
                error={errors}
                loading={isLoading}
                showContainer={false}
                hasChanges={hasChanges}
                showDeactivateToggle={showDeactivateToggle}
              />
              {(meta?.photos == 1 || meta?.settings?.photos == 1) &&
                pendingPreviewUrl && (
                  <Box mt={2}>
                    <Typography variant="body2" color="textSecondary">
                      Pending Preview (not saved yet)
                    </Typography>
                    <Box mt={1}>
                      <img
                        alt={pendingImage?.name || 'pending-photo'}
                        src={pendingPreviewUrl}
                        style={{
                          maxWidth: 200,
                          maxHeight: 200,
                          borderRadius: 4
                        }}
                      />
                    </Box>
                  </Box>
                )}
              {(meta?.photos == 1 || meta?.settings?.photos == 1) &&
                uploadedFile &&
                uploadSubId &&
                (!subAccDetails?.ixSub ||
                  uploadSubId === subAccDetails.ixSub) && (
                  <Box mt={2}>
                    <Typography variant="body2" color="textSecondary">
                      Uploaded Preview
                    </Typography>
                    <Box mt={1}>
                      <img
                        alt={uploadedFile}
                        src={`/api/images/${ixImage}/sub/${uploadSubId}/${uploadedFile}?t=${Date.now()}`}
                        style={{
                          maxWidth: 200,
                          maxHeight: 200,
                          borderRadius: 4
                        }}
                      />
                    </Box>
                  </Box>
                )}
            </Box>
          )}
        </DialogContent>
      </Dialog>
      {(meta?.photos == 1 || meta?.settings?.photos == 1) && openUploader ? (
        <ImageUploader
          open={openUploader}
          handleClose={() => setOpenUploader(false)}
          url={uploadSubId ? `/images/sub/${uploadSubId}` : ''}
          aspect={1}
          defer
          callBack={(name, file) => {
            setPendingImage({ name, file });
          }}
        />
      ) : null}
      <Box className={clsx(classes.root, className)}>
        <TextField
          className={classes.input}
          disabled={disabled()}
          fullWidth
          label={hideCaption ? '' : sSubType}
          name="SrchSub"
          value={selectedSub || selectedSubItemDetails?.sSub || ''}
          error={error}
          helperText={errorMessage}
          autoComplete="off"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton
                  aria-label="search"
                  onClick={() => {
                    setQuery('');
                    open();
                  }}
                  disabled={disabled()}
                  size={rest?.size ?? 'medium'}
                >
                  <Search fontSize={rest?.size || 'medium'} />
                </IconButton>
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                {showEdit && quick_edit && (
                  <Tooltip
                    title={
                      selectedSubItemDetails?.ixSub
                        ? `Edit ${sSubType}`
                        : `Select ${sSubType} first`
                    }
                    arrow
                  >
                    <span>
                      <IconButton
                        aria-label="edit"
                        size={rest?.size || 'medium'}
                        disabled={disabled() || !selectedSubItemDetails?.ixSub}
                        onClick={e => {
                          e.stopPropagation();
                          if (selectedSubItemDetails?.ixSub) {
                            editSubAcc(selectedSubItemDetails.ixSub);
                            open();
                          }
                        }}
                        style={{ marginRight: -15 }}
                      >
                        <Edit />
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
                <IconButton
                  aria-label="search"
                  onClick={e => {
                    e.stopPropagation();
                    setSelectedSubItem(null);
                    setSelectedSubItemDetails(null);
                    handleSubSelect({
                      ixSubAcc: '',
                      sSubAcc: '',
                      ixSub: '',
                      sSub: '',
                      sub_id: '',
                      sub_title: ''
                    });
                  }}
                  size={rest?.size || 'medium'}
                  disabled={disabled()}
                >
                  <Clear
                    fontSize={rest?.size || 'medium'}
                    style={{
                      color: disabled() ? 'rgba(0, 0, 0, 0.38)' : red[500]
                    }}
                  />
                </IconButton>
              </InputAdornment>
            ),

            classes: {
              adornedStart: classes.adornStart,
              adornedEnd: classes.adornEnd
            }
          }}
          placeholder={rest?.placeholder ?? 'Please select a sub-account...'}
          variant="outlined"
          onChange={handleSrchSub}
          size={rest?.size ?? 'medium'}
          required={required}
        />
      </Box>
    </Box>
  );
};

export default SrchSub;
